/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useEffect, useMemo, useState } from 'react';
import { useThree } from '@react-three/fiber';
import { useSelector } from 'react-redux';

import { const_var, params } from '../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, textureAnisotropy } from '../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall } from '../../../../../CustomMaterial';

const InsideWallModel = () => {
    const { gl } = useThree();
    
    const leftWallCloseState = useSelector((state) => state.reducer.leftWallCloseState)

    const [wallCloseState, setWallCloseState] = useState(0);

    const texture = const_var.metalTexture

    const wallModel = useMemo(() => {
        let model = new THREE.Shape();

        if (wallCloseState > -1) {
            model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
            model.lineTo(params.p_d / 2 + 0.15, (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
            model.lineTo(params.p_d / 2 + 0.15, 0);                
            model.lineTo(-(params.p_d / 2 + 0.15), 0);
            model.closePath()
        }  else {
            model.moveTo((params.p_d / 2 - 0.15), params.p_h - 0.001);
            model.lineTo(params.p_d / 2 - (params.add_storage_check_front ? parseInt(params.cB_addStorage_front) : 0.15), params.p_h - 0.001);
            model.lineTo(params.p_d / 2 - (params.add_storage_check_front ? parseInt(params.cB_addStorage_front) : 0.15), 0);
            model.lineTo((params.p_d / 2 - 0.15), 0);
            model.closePath()
        }
        
        return model;
        
    }, [params.p_d, params.p_h, params.p_w, wallCloseState, params.p_u_c, params.p_u_t, params.p_r_p, params.singleSlope && params.freeStandingSide === "left"], params.add_storage_check_front)

    const wallDellModel = useMemo(() => {
        let model = new THREE.Shape();
        model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, 0);
        model.lineTo(-(params.p_d / 2 + 0.15), 0);
        model.closePath()
          
        return model;
    
    }, [params.p_d, params.p_h, params.p_w, leftWallCloseState, params.p_u_c, params.p_u_t, params.p_r_p,params.singleSlope && params.freeStandingSide === "left", params.p_w_c_n, params.p_l_w])

    /************** cutting hole using CSG ***************/

    const CSGWallModelGeometry = useMemo(() => {
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wallModel, extrudeSettings(0.005)))
        const meshWallDellModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wallDellModel, extrudeSettings(0.005)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('left', 'wall'), extrudeSettings(1)))
    
        let meshWallModel_Temp = meshWallModel.clone();
        let meshDelModel_Temp = meshDelModel.clone();
        let meshWallDelModel_Temp = meshWallDellModel.clone();
        meshDelModel_Temp.position.set(-params.endStoragePositionZ, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld();

        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshWallDelModel_CSG = CSG.fromMesh(meshWallDelModel_Temp);
    
        const wallModel_CSG_temp = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const wallModel_CSG = wallModel_CSG_temp.intersect(meshWallDelModel_CSG);
        const CSGWallModel = CSG.toMesh(
            wallModel_CSG,
            new THREE.Matrix4()
        )

        return CSGWallModel.geometry;
    
        /****************************************** *********/

    }, [params.p_d, params.p_h, params.p_w, params.endStoragePositionZ, wallCloseState, params.p_u_c, params.p_u_t, params.p_r_p, params.singleSlope && params.freeStandingSide === "left", params.add_storage_check_front, leftWallCloseState, params.p_w_c_n, params.p_l_w, const_var.newDoorsArray]);

    useMemo(() => {
        var wallCloseValue = -1;
        var tempCutState = -1;
        let leanHeightValue = -1;
        let finalHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) : params.p_h
        
        if ((params.p_l_w === 'Open' && !params.p_u_c) || typeof(params.p_l_w) === 'object') {
            wallCloseValue = -1;
        } else if (params.p_l_w === "One_Fourth_Close") {
            wallCloseValue = (finalHeight * 3) / 4;
        } else if (params.p_l_w === "Half_Close") {
            wallCloseValue = finalHeight / 2;
        } else if (params.p_l_w === "Three_Fourth_Close") {
            wallCloseValue = finalHeight / 4;
        } else if (params.p_l_w === "Close") {
            wallCloseValue = 0;
        } else {
            wallCloseValue = finalHeight - (3 * params.p_l_w) - 0.2;
        }

        if (params.p_c_p_l) {
            if ((params.p_l_w === 'Open' && !params.p_u_c) || typeof(params.p_l_w) === 'object') {
                tempCutState = finalHeight - 1.5;
            } else {
                tempCutState = wallCloseValue - 1.5;
            }
        } else {
            tempCutState = wallCloseValue;
        }
        if (params.add_left_lean) {
            leanHeightValue = params.lean_p_h + params.lean_p_w * (params.b_l_t_r_p / 12);

            // if (tempCutState === -1 || tempCutState > leanHeightValue || (tempCutState < leanHeightValue && leanHeightValue > (params.p_h - Math.ceil((params.p_h - tempCutState) / 3) * 3) && leanHeightValue < (params.p_h - (Math.ceil((params.p_h - tempCutState) / 3) - 1) * 3))) {
            if (tempCutState > leanHeightValue || (tempCutState < leanHeightValue && leanHeightValue > (params.p_h - Math.ceil((params.p_h - tempCutState) / 3) * 3) && leanHeightValue < (params.p_h - (Math.ceil((params.p_h - tempCutState) / 3) - 1) * 3))) {
                setWallCloseState(leanHeightValue - 0.2);
            } else {
                /** cutting panel options isn't disabled when wall close state over limit */
                if (tempCutState > 0) {
                    setWallCloseState(tempCutState);
                } else {
                    if ((params.p_l_w === 'Open' && !params.p_u_c) || typeof(params.p_l_w) === 'object') {
                        setWallCloseState(-1);
                    } else {
                        setWallCloseState(0);
                    }
                }
            }
        } else {
            /** cutting panel options isn't disabled when wall close state over limit */
            if (tempCutState > 0) {
                setWallCloseState(tempCutState);
            } else {
                if ((params.p_l_w === 'Open' && !params.p_u_c) || typeof(params.p_l_w) === 'object') {
                    setWallCloseState(-1);
                } else {
                    setWallCloseState(0);
                }
            }
        }
    }, [params.p_l_w, params.p_c_p_l, params.p_h, params.p_w, params.add_left_lean, params.lean_p_h, params.lean_p_w, params.b_l_t_r_p, params.cB_addStorage_check_left,params.p_u_c,params.singleSlope && params.freeStandingSide === "left"])

    useEffect(() => {
        textureAnisotropy(gl, texture, 1.3, 1.3, params.p_v_w ? Math.PI / 2 : 0);    
    }, [params.p_v_w,wallCloseState])    
    
    return CSGWallModelGeometry && (
        <mesh name="c_b_l_s_w_left_leg_inside_wall" geometry={CSGWallModelGeometry} position={[-(params.p_w / 2 - 0.07), 0, 0]} rotation={[0, -Math.PI / 2, 0]}>
            <MaterialInnerWall texture={texture} visibleSection={"center"} />
        </mesh>
    )
}

export default InsideWallModel